import { useCallback } from "react";
import { useLenis } from "lenis/react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import BrandMarquee from "@/components/BrandMarquee";
import WhyUs from "@/components/WhyUs";
import WaitlistFooter from "@/components/WaitlistFooter";
import { useWaitlistCount } from "@/hooks/useWaitlistCount";

export default function Landing() {
  const lenis = useLenis();
  const { count, refresh } = useWaitlistCount();

  const scrollToWaitlist = useCallback(() => {
    const el = document.getElementById("waitlist");
    if (!el) return;
    if (lenis) {
      lenis.scrollTo(el, { offset: 0, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
    setTimeout(() => {
      const input = document.querySelector('[data-testid="waitlist-phone-input"]');
      if (input) input.focus({ preventScroll: true });
    }, 1200);
  }, [lenis]);

  return (
    <main className="bg-white" data-testid="landing-page">
      <Navbar onJoin={scrollToWaitlist} />
      <Hero onJoin={scrollToWaitlist} count={count} />
      <HowItWorks />
      <BrandMarquee />
      <WhyUs />
      <WaitlistFooter count={count} onJoined={refresh} />
    </main>
  );
}
